namespace $.$$ {
	$mol_style_define( $shm_projects_goal_request, {
		flex: { direction: 'column' },
		gap: $mol_gap.block,
		padding: $mol_gap.block,
		background: { color: $mol_theme.card },
		border: {
			radius: $mol_gap.round,
		},
		minWidth: 0,

		Attachments: {
			gap: $mol_gap.block,
		},

		Attachment: {
			alignItems: 'center',
			gap: $mol_gap.text,
			minWidth: 0,
			padding: $mol_gap.text,
			background: { color: $mol_theme.hover },
			border: { radius: $mol_gap.round },
		},

		Attachment_image: {
			width: '4rem',
			height: '4rem',
			objectFit: 'cover',
			border: { radius: $mol_gap.round },
		},

		Attachment_name: {
			flex: { grow: 1 },
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		Attachment_remove: {
			padding: $mol_gap.text,
		},

		'@': {
			shm_projects_goal_request_drag: {
				true: {
					boxShadow: `inset 0 0 0 1px ${ $mol_theme.current }`,
					background: { color: $mol_theme.hover },
				},
			},
		},
	} )
}
